import type { IOrdersEdgesNode } from "@repo/shopify/types/api/customer";

import { useCartStore } from "@store/cart";
import { useCustomerStore } from "@store/customer";

/**
 * 토스 임직원 구매 한도 체크
 */
export default function useCheckPurchaseLimit() {
  const { cart } = useCartStore();
  const { customer } = useCustomerStore();

  const purchaseLimit = 2000000;
  const startYear = new Date(new Date().getFullYear(), 0, 1);

  const cartTotal = Number(cart.cost.totalAmount.amount);
  const orderTotal = customer.orders.edges
    .filter(({ node }) => (node as IOrdersEdgesNode)?.isfamilysale?.value !== "true")
    .filter(({ node }) => new Date(node.processedAt) >= startYear)
    .reduce((total, { node }) => total + Number(node.currentTotalPrice.amount), 0);

  // 남은 한도 금액
  const remainingLimit = purchaseLimit - orderTotal;
  // 남은 한도 예상 금액
  const expectedRemainingLimit = remainingLimit - cartTotal;

  return { purchaseLimit, orderTotal, remainingLimit, expectedRemainingLimit };
}
